import {
  monetary_programs_list,
  monetary_programs_create,
  monetary_programs_read,
  monetary_programs_delete,
} from "@/lib/api-client.js";
import { getAxiosConfig as axconf } from "@/lib/api-config.js";

import Vue from "vue";

export default {
  namespaced: true,
  state: {
    programs: [],
    program_patient: [],
  },
  actions: {
    REQUEST_PROGRAMS: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        monetary_programs_list({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          patientExclude: payload.patientExclude,
        }).then(
          response => {
            commit("MUTATE_PROGRAMS", {
              data: response.data,
            });
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_PROGRAM_PATIENT: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        monetary_programs_read({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          ptUuid: payload.pt_uuid,
        }).then(
          response => {
            commit("MUTATE_PROGRAM_PATIENT", {
              data: response.data,
            });
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    NEW_PROGRAM_PATIENT: (undefined, payload) => {
      return new Promise((resolve, reject) => {
        monetary_programs_create({
          data: payload.data,
          ptUuid: payload.pt_uuid,
          role: "vooyguest",
          roleUuid: "1",
          $config: axconf(),
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    DELETE_PROGRAM_PATIENT: (undefined, payload) => {
      return new Promise((resolve, reject) => {
        monetary_programs_delete({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          ptUuid: payload.pt_uuid,
          pUuid: payload.p_uuid,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
  },
  mutations: {
    MUTATE_PROGRAMS: (state, payload) => {
      Vue.set(state, "programs", payload.data.results);
    },
    MUTATE_PROGRAM_PATIENT: (state, payload) => {
      Vue.set(state, "program_patient", payload.data.results);
    },
  },
};
